<template>
  <div class="flex flex-row mx-auto" style=" justify-content: space-between; align-items: center;">
    <span class="box" :style="'background:' + requiredField.color + ';'">
    </span>
    <div
      class="h-min roundedcursor-pointer py-4"
      @click="addNew(requiredField.id, requiredField.name)"
    >
      <h2
        v-if="requiredField.name == selectedFieldName"
        class="text-2xl font-bold text-red-600 ml-2"
        :style="' color:' + requiredField.color + ';'"
      >
        {{ requiredField.name }}
      </h2>

      <h2
        v-else
        class="text-2xl font-bold text-gray-800 ml-2"
        :style="' color:' + requiredField.color + ';'"
      >
        {{ requiredField.name }}
      </h2>
    </div>
    <button
      aria-label="Field Show"
      class="action-button focus:outline-none focus:shadow-outline ml-4"
      @click="togglefunction(requiredField.id)"
    >
      <EyeIcon v-if="toggleFields" />
      <EyeOffIcon v-else />
    </button>
  </div>
</template>
<script>
import Vue from "vue";
import _ from "lodash";
import VueTailwind from "vue-tailwind";
Vue.use(VueTailwind);
import { EyeIcon, EyeOffIcon } from "@vue-hero-icons/outline";
export default {
  data() {
    return {
      toggleFields: false,
    };
  },

  watch: {},

  methods: {
    togglefunction(fieldId) {
      this.toggleFields = !this.toggleFields;
      this.$emit("toggleFieldPolygons", fieldId);
    },
  },
  created() {},

  components: {
    EyeIcon,
    EyeOffIcon,
  },
  props: {
    requiredField: {
      type: Object,
      default: () => ({}),
    },
    selectedFieldName: String,
    addNew: { type: Function },
  },
};
</script>
